<div class="pr-tainer rulesets-page">
  <div class="container">
    <div class="header-row">
      <div>
        <h3 class="page-title">SRC Rules</h3>
        <p class="section-desc">SRC Rules are a way to manage health, usage and equipment rules for different patient sets.</p>
      </div>
      <button class="fab" *ngIf="showAddRuleSetFab" (click)="addRuleSet()"><span>+</span></button>
    </div>
    <div class="ruleset-card">
      <h2 class="ruleset-name section-title">{{selectedRuleSet?.title}}</h2>
      <p class="ruleset-info section-desc">The following are the health, usage and equipment rules assigned to the patient via Rule Set selection. Rules are editable and can be enabled/disabled. Changes to the rules will be applied to the patient moving forward.</p>
      <ng-container *ngIf="pagedRules.length > 0; else noRules">
        <div *ngFor="let rule of pagedRules" class="ruleset-rule">
          <div class="ruleset-rule-row">
            <label class="switch">
              <input type="checkbox" [(ngModel)]="rule.enabled" (change)="toggleRule(rule)">
              <span class="slider round"></span>
            </label>
            <span class="rule-title section-title" [class.enabled]="rule.enabled">{{rule.title}}</span>
            <button class="icon-btn" (click)="editRule(rule)" title="Edit rule">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 17.25V21h3.75l11.06-11.06-3.75-3.75L3 17.25zM20.71 7.04a1.003 1.003 0 0 0 0-1.42l-2.34-2.34a1.003 1.003 0 0 0-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.82z" fill="#1976d2"/>
              </svg>
            </button>
          </div>
          <div class="rule-when-then">
            <div class="when">
              <span class="when-title section-title">When</span>
              <p class="section-desc">{{rule.when}}</p>
            </div>
            <div class="then">
              <span class="then-title section-title">Then</span>
              <ul>
                <li *ngFor="let thenLine of rule.then.split('\n')">{{thenLine}}</li>
              </ul>
            </div>
          </div>
          <hr class="rule-divider" />
        </div>
      </ng-container>
      <ng-template #noRules>
        <div class="no-rules-message">No rules found for this page.</div>
      </ng-template>
    </div>
    <div class="pagination-row" *ngIf="totalPages > 1">
      <span class="pagination-info">
        Showing {{ planDefinitionRules.length === 0 ? 0 : ((page-1)*pageSize+1) }}-{{
          planDefinitionRules.length === 0 ? 0 :
          (page*pageSize > planDefinitionRules.length ? planDefinitionRules.length : page*pageSize)
        }} of {{ planDefinitionRules.length }}
      </span>
      <button class="pagination-btn" [disabled]="page === 1" (click)="prevPage()">&#60;</button>
      <button class="pagination-btn" [disabled]="page === totalPages" (click)="nextPage()">&#62;</button>
    </div>
  </div>
</div>
    <div class="pagination-row" *ngIf="totalPages > 1">
      <span class="pagination-info">
        Showing {{ planDefinitionRules.length === 0 ? 0 : ((page-1)*pageSize+1) }}-{{
          planDefinitionRules.length === 0 ? 0 :
          (page*pageSize > planDefinitionRules.length ? planDefinitionRules.length : page*pageSize)
        }} of {{ planDefinitionRules.length }}
      </span>
      <button class="pagination-btn" [disabled]="page === 1" >&#60;</button>
      <button class="pagination-btn" [disabled]="page === totalPages" >&#62;</button>
    </div>
<!-- Add/Edit RuleSet Modal (moved outside main container for overlay) -->
<div class="modal-backdrop" *ngIf="showAddRuleSetModal || showEditRuleSetModal">
    <div class="modal add-ruleset-modal">
      <div class="modal-header">
        <span class="modal-title">{{showEditRuleSetModal ? 'Edit Rule' : 'Add Rule'}}</span>
        <button class="modal-close" (click)="showEditRuleSetModal ? showEditRuleSetModal = false : closeAddRuleSetModal()">&times;</button>
      </div>
      <div class="modal-body">
          <form (ngSubmit)="showEditRuleSetModal ? null : saveNewRuleSet()">
            <div class="modal-form-row">
              <label for="ruleSetTitleModal">*Name</label>
              <input id="ruleSetTitleModal" name="ruleSetTitleModal" type="text" maxlength="100" [(ngModel)]="ruleSetToEdit.title" required />
            </div>
            <div class="modal-form-row">
              <label for="ruleSetDescriptionModal">Short description</label>
              <textarea id="ruleSetDescriptionModal" name="ruleSetDescriptionModal" maxlength="300" [(ngModel)]="ruleSetToEdit.description"></textarea>
              <div class="char-count">Maximum 300 characters : <span class="char-remaining">{{300 - (ruleSetToEdit.description?.length || 0)}} remaining</span></div>
            </div>
            <div class="modal-form-row">
              <div class="tab-group">
                <button type="button" class="tab" [class.active]="selectedRuleType === 'Health'" (click)="setRuleType('Health')">Health</button>
                <button type="button" class="tab" [class.active]="selectedRuleType === 'Usage'" (click)="setRuleType('Usage')">Usage</button>
                <button type="button" class="tab" [class.active]="selectedRuleType === 'Prescription'" (click)="setRuleType('Prescription')">Prescription</button>
                <button type="button" class="tab" [class.active]="selectedRuleType === 'Equipment'" (click)="setRuleType('Equipment')">Equipment</button>
              </div>
            </div>
            <div class="dual-list-row">
              <div class="dual-list available">
                <label for="availableFilterModal">Available</label>
                <input id="availableFilterModal" name="availableFilterModal" type="text" placeholder="Filter" [(ngModel)]="availableFilter" />
                <ul>
                  <li *ngFor="let item of filteredAvailableItems" (click)="selectAvailableItem(item)">{{item}}</li>
                </ul>
              </div>
              <div class="dual-list-controls">
                <button type="button" (click)="moveToSelected()">&rarr;</button>
                <button type="button" (click)="moveToAvailable()">&larr;</button>
              </div>
              <div class="dual-list selected">
                <label for="selectedFilterModal">Selected</label>
                <input id="selectedFilterModal" name="selectedFilterModal" type="text" placeholder="Filter" [(ngModel)]="selectedFilter" />
                <ul>
                  <li *ngFor="let item of filteredSelectedItems" (click)="selectSelectedItem(item)">{{item}}</li>
                </ul>
                <div class="selected-count">{{selectedItems.length}} of {{availableItems.length}} Selected</div>
              </div>
            </div>
          </form>
      </div>
      <div class="modal-footer">
        <button class="modal-cancel" (click)="showEditRuleSetModal ? showEditRuleSetModal = false : closeAddRuleSetModal()">Cancel</button>
        <button class="modal-save" (click)="showEditRuleSetModal ? null : saveNewRuleSet()">Save</button>
      </div>
    </div>
  </div>
